import { Subject } from "rxjs";
import { BasespaceFormArray, BasespaceFormControl, BasespaceFormProperties } from "../bs-app-launch-form-control";
import { BsAppLaunchTabularFieldSetControlComponent } from "./bs-app-launch-tabular-field-set-control.component";
import { FormArray } from "@angular/forms";

export interface TabularFieldSetFormProperties extends BasespaceFormProperties<BsAppLaunchTabularFieldSetControlComponent> {
    fields: BasespaceFormProperties<any>[];
    fieldCells: BasespaceFormProperties<any>[][];

    seriesHeader: string;
    headers: string[];
    footers: string[];
    maxRows: number;
}

export interface RowAction {
    action: 'Remove'

    // 0 indexed
    rowIndex: number;
}

// Reference docs: https://dagobah-developer.cloud-test.illumina.com/docs/content/documentation/apptools/formbuilder-overview#TabularFieldSet
// Reference class: src/Cloud.FormBuilder/Models/TabularFieldSet.cs

export class TabularFieldSetFormControl extends BasespaceFormArray<BsAppLaunchTabularFieldSetControlComponent> implements TabularFieldSetFormProperties {
    fields: BasespaceFormProperties<any>[];
    fieldCells: BasespaceFormProperties<any>[][];
    seriesHeader: string;
    headers: string[];
    footers: string[];

    maxRows: number;

    rowActionSubject: Subject<RowAction>;

    get rowCount(): number {
        return this.controls.length;
    }

    // id generation for cell: clone.Id = $"{table.Id}.{field.Id}.row{rowNumber}";
    // id for each cell is generated and applied to control in the app launch field renderer component
    
    constructor(
        data: TabularFieldSetFormProperties
    ) {
        const { 
            id, 
            componentReference, 
            label,
            helpText, 
            fields, 
            fieldCells,
            headers, 
            seriesHeader,
            footers,
            maxRows,
            formControlType
         } = data;
        super({ id, componentReference, label, helpText, formControlType });

        this.headers = headers || [];
        this.footers = footers || [];
        this.seriesHeader = seriesHeader || '';
        this.maxRows = maxRows || null;

        this.fieldCells = fieldCells || null;
        this.fields = fields || [];

        this.fields.forEach((field, index) => {
            if(!this.headers || !this.headers[index]) {
                field.tabularFieldSetStyling = true;
            }
        });

        this.rowActionSubject = new Subject();

    }

    getRequestEntries(): any[][] {
        return [[`${this.id}.rowcount`, this.rowCount]];
    }

    destroy(): void {
        this.controls.forEach((control: FormArray) => {
            control.controls.forEach((control: BasespaceFormControl<any>)=> {
                control.destroy();
            });
        });

        // This should always be true. Children can be FormArrays or FormControls but parents will always be FormArrays
        // to keep things consistent.
        const parentControl = this.parent as FormArray;
        if(parentControl) {
            const index = (parentControl.controls).findIndex((control) => (control as BasespaceFormControl<any>).id === this.id);
            parentControl.removeAt(index);
        }
        
        this.subs.unsubscribe();
        this.componentReference.destroy();
    }

}